module.exports = __webpack_public_path__ + "media/images/index/flim-4648eec9ac1f8c70e137b20b3ea5ff86.svg";